export default __webpack_public_path__ + "static/l1-hero-img-2-75491b32760557bb58590ec61b1978de.png";